import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import type { LegalTransition } from "@/lib/jobs";

export interface TransitionMenuProps {
  transitions: LegalTransition[];
  onSelect: (t: LegalTransition) => void;
  disabled?: boolean;
}

export function TransitionMenu({ transitions, onSelect, disabled }: TransitionMenuProps) {
  if (transitions.length === 0) {
    return (
      <Button disabled variant="outline" size="sm">
        No transitions
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button disabled={disabled} variant="outline" size="sm" aria-label="Change status">
          Change status…
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {transitions.map((t) => (
          <DropdownMenuItem key={t.targetStatusCode} onSelect={() => onSelect(t)}>
            <span
              className="inline-block size-2 rounded-full mr-2"
              style={{ backgroundColor: t.color ?? "#94A3B8" }}
              aria-hidden
            />
            {t.targetStatusLabel}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
